// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"597":"projects","884":"admin"}[chunkId] + "." + {"597":"6cd758f2","884":"35b884e3"}[chunkId] + ".css";
};